import React from 'react';
import {Link} from 'react-router-dom';
import '../config.js';

import { theme } from '../services/helper.js';

function UserListItem(props) {
  
  let statusClass = "text-gray-500";
  if(props.info.active){
    statusClass = "";
  }
  let role = "None";
  if(props.info.role == 4){
    role = "Sub Admin";
  }else if(props.info.role == 5){
    role = "Admin";
  }else if(props.info.role == 10){
    role = "Super Admin";
  }
  return(
        <tr className={statusClass}>
          <td>{props.info.name}</td>
          <td>{props.info.email}</td>
          <td>{props.info.mobile}</td>
          <td>{role}</td>
          <td>{props.info.status}</td>
          <td>
            <Link to={"/user/"+props.info.user_id} className={'btn btn-icon-split btn-'+theme()}>
              <span className="icon text-white-50">
                <i className="fas fa-edit"></i>
              </span>
              <span className="text">Edit</span>
            </Link>
          </td>
        </tr>
  )
}

export default UserListItem;